//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

module.exports = {
  host: process.env.REACT_APP_API_URL
};
